import { ProgressBar } from "./Progress";
import { BuzerIcon } from "../../../BuzerIcons";

// Section divider — mono uppercase label + a hairline rule + an optional count.
// Pass `onClick` (+ a `trailing` chevron) to turn it into a collapse toggle, or
// `pct` to add a routine-style progress bar under the row, or `icon` for a leading
// glyph (e.g. "Uložené rady" + pin, "Rebríček" + trophy). The count-and-hairline
// pattern used across the Plán/Pripomienky lists lives here now.
// v34 — label štýl žije v jednej globálnej CSS triede .bz-sectlabel (primitives.css),
// ktorú zdieľajú VŠETKY section labely appky (Máš čas, Rebríček, Odznaky, Archív…).
export function SectionHeader({ label, count, trailing, onClick, pct, icon, style }) {
  const El = onClick ? "button" : "div";
  const rowStyle = {
    display: "flex", alignItems: "center", gap: 10, margin: "18px 3px 9px",
    ...(onClick ? { width: "100%", background: "none", border: "none", cursor: "pointer", padding: 0, font: "inherit", textAlign: "left", color: "inherit", WebkitTextFillColor: "currentColor" } : {}),
    ...style,
  };
  return (
    <>
      <El type={onClick ? "button" : undefined} onClick={onClick} style={rowStyle}>
        <span className="bz-sectlabel" style={{ display: "inline-flex", alignItems: "center", gap: 5 }}>
          {icon && <BuzerIcon name={icon} size={13} color="currentColor" />}
          {label}
        </span>
        <span style={{ flex: 1, height: 1, background: "var(--neutral-border)" }} />
        {count != null && <span className="bz-sectlabel" style={{ letterSpacing: 0 }}>{count}</span>}
        {trailing}
      </El>
      {pct != null && <ProgressBar pct={pct} size="sm" />}
    </>
  );
}
